import React, { PureComponent } from "react";
import { ResponsiveContainer, PieChart, Pie, Cell } from "recharts";

import ResponsiveChart from "components/RunPlot/ResponsiveChart";

class PieChartComponent extends PureComponent {
  render() {
    const { probability } = this.props;

    const data = [
      { name: "False", value: 1 - probability, fill: "rgba(242, 243, 247, 1)" },
      { name: "True", value: probability, fill: "var(--aible-color)" }
    ];
    return (
      <ResponsiveContainer>
        <PieChart onMouseEnter={this.onPieEnter}>
          <Pie
            data={data}
            innerRadius={80}
            outerRadius={90}
            fill="#8884d8"
            paddingAngle={0}
            dataKey="value"
            startAngle={90}
            endAngle={450}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.fill} />
            ))}
          </Pie>
          {/* <Tooltip /> */}
        </PieChart>
      </ResponsiveContainer>
    );
  }
}

export default ResponsiveChart(PieChartComponent);
